export default __webpack_public_path__ + "static/media/Nuleep-Light-Green.44162d37.svg";